import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import '../Workflow.scss';
import WorkflowTask from '../../../../../components/library/workflow-tasks/WorkflowTask';
import Button from '../../../../../components/library/buttons/Button';
import { WorkflowTasks } from '../../../services/WorkflowTasks';
import { TaskStatus } from '../../../services/TaskStatus';
import { useTicketState } from '../../hooks/useTicketStateHook';
import WorkflowTaskDescriptionWithHelp from '../../../../../components/library/workflow-tasks/WorkflowTaskDescriptionWithHelp';

const ReviewReturnVirTask = (props) => {
    const [status, setStatus] = useState(TaskStatus.NOT_STARTED);
    const ticketIsOpen = useTicketState(props.ticket);

    const handleLaunchTPSAction = () => {
        let myWindow = window.open();
        if (status === TaskStatus.NOT_STARTED) {
            setStatus(TaskStatus.IN_PROGRESS);
        }
        myWindow.location.href = localStorage.getItem('tps_base_uri') + `/${props.ticket.taxYear}/return/${props.ticket.viewModelId}?isvir=true`;
    }

    useEffect(() => {
        var confirmReadyToFile = props.ticket.taskCompletionStates.filter(x => x.workflowTaskId === WorkflowTasks.VIR_READY_TO_FILE)

        var confirmASigning = props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === 'RC71_P').length > 0 ||
            props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === 'POA_P').length > 0 ||
            props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === 'RETURN_REVIEWED').length > 0;       

        if (status === TaskStatus.NOT_STARTED && confirmASigning) {
            setStatus(TaskStatus.IN_PROGRESS);
        }

        if (status === TaskStatus.IN_PROGRESS && props.readyToFile) {
            setStatus(TaskStatus.COMPLETE);
        }

        if (confirmReadyToFile.length > 0) {
            setStatus(TaskStatus.COMPLETE);
        }

    }, [props.ticket, props.readyToFile])

    return (
        <WorkflowTask status={status} taskId={WorkflowTasks.REVIEW_RETURN}>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    helpKey='0ProSupport/VDOPro/ReviewReturn.htm'
                    descriptions={['ReviewReturnVirTask.Step', 'ReviewReturnVirTask.StepDesc']} />
            </div>
            <div className='columns'>
                <div className='column is-10 is-offset-1'>
                    <div className='step-center-container'>
                        {props.ticket &&
                            <Button
                            elementId='launch-tps-btn'
                            labelKey='PrepareTask.LaunchTPSBtn'
                            buttonStyles='secondary'
                            onClick={handleLaunchTPSAction}
                            loading={false}
                            />}
                    </div>
                </div>
            </div>
        </WorkflowTask>
    );
}

ReviewReturnVirTask.whyDidYouRender = false;

ReviewReturnVirTask.propTypes = {
    ticket: PropTypes.object
}

export default ReviewReturnVirTask